import { z } from "zod";

export const MAX_PERIOD_COUNT = 10 * 12;

export const RtPeriodIndex = z.number().int().min(0).max(MAX_PERIOD_COUNT);
